// extracted by mini-css-extract-plugin
export default {"logReport":"LogReport_logReport__-Uv2r"};